export default "__VITE_ASSET__Cl2RiUum__"